export default __webpack_public_path__ + "static/media/Zoom.d471eed0.svg";